import isEmail from 'validator/lib/isEmail';
import isURL from 'validator/lib/isURL';

export const SUPPORTED_AUDIO_FORMATS = ['mp3', 'ogg', 'wav'] as const;

export const ATTACHED_DATA_VALUE_TYPES = {
  MARKDOWN_LINK: 'markdown-link',
  AUDIO: 'audio',
  LINK: 'link',
  TEXT: 'text',
} as const;

// Matches inline markdown links [display text](url): group 1 = text, group 2 = url
const MARKDOWN_URL_REGEX = /^\[([^\]]+)\]\(([^)]+)\)$/;

export type TAttachedDataValueType =
  | { type: typeof ATTACHED_DATA_VALUE_TYPES.MARKDOWN_LINK; text: string; url: string }
  | { type: typeof ATTACHED_DATA_VALUE_TYPES.AUDIO; url: string }
  | { type: typeof ATTACHED_DATA_VALUE_TYPES.LINK; url: string }
  | { type: typeof ATTACHED_DATA_VALUE_TYPES.TEXT };

function isSupportedAudioUrl(data: string): boolean {
  if (!isURL(data, { require_protocol: true })) {
    return false;
  }

  const pathname = new URL(data).pathname.toLowerCase();
  return SUPPORTED_AUDIO_FORMATS.some((format) => pathname.endsWith(`.${format}`));
}

export function parseAttachedDataValue(data: string): TAttachedDataValueType {
  const markdownMatch = data.match(MARKDOWN_URL_REGEX);

  if (markdownMatch) {
    return { type: ATTACHED_DATA_VALUE_TYPES.MARKDOWN_LINK, text: markdownMatch[1], url: markdownMatch[2] };
  }

  if (isSupportedAudioUrl(data)) {
    return { type: ATTACHED_DATA_VALUE_TYPES.AUDIO, url: data };
  }

  // isURL doesn't recognise mailto:, so check for that explicitly
  if (isURL(data, { require_protocol: false }) || isEmail(data) || data.startsWith('mailto:')) {
    return { type: ATTACHED_DATA_VALUE_TYPES.LINK, url: data };
  }

  return { type: ATTACHED_DATA_VALUE_TYPES.TEXT };
}
